import React, {useEffect, useState} from 'react';
import axios from "axios";
import {Container, Row, Col, Button} from "react-bootstrap";
import {useParams} from "react-router-dom";
import Layout from "../../components/Layout";
import NoMatch from "../NoMatch";
import Spinner from "../../components/Spinner/Spinner";


const NewsDetails = () => {
    const [posts, setPosts] = useState({})
    const [isLoading, setIsLoading] = useState(true)
    const [notFound, setNotFound] = useState(false)

    const {id} = useParams()

    useEffect(() => {
        axios(`https://613af3f5110e000017a453df.mockapi.io/News/${id}`)
            .then(({data}) => setPosts(data))
            .catch(() => setNotFound(true))
            .finally(() => setIsLoading(false))
    }, [id])

    if (isLoading) {
        return <Spinner/>
    }
    if (notFound) {
        return <NoMatch/>
    }
        return (
            <Layout>
                <Container>
                    <Row>
                        <Col md={5}>
                            <img src={posts.image} alt=""/>
                        </Col>
                        <Col md={7}>
                            <h3>{posts.title}</h3>
                            <p>{posts.desc}</p>
                            <i>{posts.author}</i> <br/>
                            <span>{posts?.createdAt?.slice(0, 10)}</span>
                        </Col>
                        <div>
                            <h3>Comments:</h3>
                            <p>John Doe <span>12.09.2021</span></p>
                            <p>It would be great!</p>
                            <textarea name="" id="" cols="30" rows="5" placeholder='Add new comment...'/> <br/>
                            <Button className='btn' variant="success">Add comment</Button>
                        </div>
                    </Row>
                </Container>
            </Layout>
        );
};

export default NewsDetails;